import _Typography from "@mui/material/Typography";
import _Tooltip from "@mui/material/Tooltip";
import _IconButton from "@mui/material/IconButton";
import _Close from "@mui/icons-material/Close";
import { ThemeProvider } from '@mui/material/styles';
import React, { useState } from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
import BikeStationAvailabilities from '../bike-station-availabilities';
import BikeStationHistoryChart from '../bike-station-history-chart';
import { Button } from '../button';
function BikeStationPopup({
  theme,
  bikeStation: _bikeStation,
  search,
  enqueueSnackbar,
  onUpdated,
  onSearchUpdated,
  onClose
}) {
  const [bikeStation, setBikeStation] = useState(_bikeStation);
  const [history, setHistory] = useState();
  function handleLeaveFromHere() {
    search?.wayPoints.splice(0, 1, bikeStation.location.clone());
    onSearchUpdated?.();
  }
  function handleGoThere() {
    search?.wayPoints.splice(-1, 1, bikeStation.location.clone());
    onSearchUpdated?.();
  }
  const {
    label,
    location
  } = bikeStation;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(CloseButtonWrapper, null, /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "left",
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: () => onClose(),
    size: "small"
  }, /*#__PURE__*/React.createElement(_Close, null)))), /*#__PURE__*/React.createElement(StyledHeader, null, /*#__PURE__*/React.createElement(StyledTitle, {
    title: label,
    variant: "subtitle1"
  }, label), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, location.address)), /*#__PURE__*/React.createElement(StyledContent, null, /*#__PURE__*/React.createElement(BikeStationAvailabilities, {
    bikeStation: bikeStation,
    enqueueSnackbar: enqueueSnackbar,
    onUpdated: onUpdated,
    setBikeStation: setBikeStation,
    setHistory: setHistory
  }), /*#__PURE__*/React.createElement(BikeStationHistoryChart, {
    bikeStation: bikeStation,
    history: history
  })), search && /*#__PURE__*/React.createElement(StyledActions, null, /*#__PURE__*/React.createElement(Button, {
    color: "inherit",
    onClick: handleLeaveFromHere,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.leave_from_here"
  })), /*#__PURE__*/React.createElement(Button, {
    color: "inherit",
    onClick: handleGoThere,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.go_there"
  })))));
}
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: max(calc(50vh - 24px), 400px);
  overflow-y: hidden;
  position: relative;
  width: min(100vw - 120px, 400px);
`;
const CloseButtonWrapper = styled.div`
  padding: 8px;
  position: absolute;
  right: 0;
  top: 0;

  button {
    background-color: rgba(255, 255, 255, 0.9);

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
`;
const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding: 16px 58px 8px 16px;
`;
const StyledTitle = styled(_Typography)`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const StyledContent = styled.div`
  border-top: 1px solid #ddd;
  flex-shrink: 1;
  overflow-y: auto;
  padding: 16px 24px;
`;
const StyledActions = styled.div`
  align-items: center;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  height: 48px;
  padding: 0 16px;

  button {
    margin-left: 8px;
  }
`;
export default BikeStationPopup;